import { useState } from 'react';

const useLoadingState = () => {
  const [isLoading, setIsLoading] = useState(false);

  const open = () => setIsLoading(true);
  const close = () => setIsLoading(false);

  return {
    isLoading,
    open,
    close,
  };
};

export default useLoadingState;
